import { inject, Injectable } from '@angular/core';
import { ApiDependencyProviderService } from '@web/common';
import { map, Observable } from 'rxjs';
import { blank, valueOrDefault } from '@web/utils';
import { AdminValidationSettingsResponse } from '../responses/admin-validation-settings.response';
import { AdminValidationSettingsUpdateRequest } from '../requests/admin-validation-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminValidationSettingsApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  public fetchSettings(options: {
    skipByLoading?: boolean;
  }): Observable<AdminValidationSettingsResponse> {
    const path = 'admin/settings/validation';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .withOptionalSkipByLoadingInterceptor(() =>
        valueOrDefault(options?.skipByLoading, false),
      )
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(
          this.provider.httpHelper.bodyToResponse(
            AdminValidationSettingsResponse,
          ),
        ),
      );
  }

  public updateSettings(
    request: AdminValidationSettingsUpdateRequest,
  ): Observable<void> {
    const path = 'admin/settings/validation';
    const url = this.provider.httpUrlFactory.withQueryParams(
      this.hostUrl(),
      path,
      {},
    );
    const body = this.provider.httpHelper.requestToBody(
      request,
      AdminValidationSettingsUpdateRequest,
    );
    const context = this.provider.httpContextBuilder
      .skipByHttpErrorInterceptor()
      .build();

    return this.provider.http.put(url, body, { context }).pipe(blank());
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
